import serialize from "json-form-data";
import moment from "moment";
import { param } from "@/utils/url/param";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    store: {},

    mutations: {},

    actions: {
        // получение данных
        async getData(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/vacations/index",
                // from: params.from,
                // to: params.to,
                // from_dt: params.from_dt,
                // to_dt: params.to_dt,
                // worker_name: params.worker_name,
                ...params
            };

            searchParams = param(searchParams);

            // let postParams = serialize({
            //     filials: params.filials,
            //     posts: params.posts,
            //     types: params.types
            // });

            const res = await fetch(`${api_url}/?${searchParams}`);

            const json = await res.json();
            
            return json;
        },

        // получение групп
        async getGroups(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/vacations/group",
                ...params
            };

            searchParams = param(searchParams);
            const res = await fetch(`${api_url}/?${searchParams}`);

            const json = await res.json();

            return json;
        },

        async createVacation(ctx, params) {
            const token = ctx.rootState.authToken;

            const body = serialize({
                category: params.type,
                worker_id: params.employee,
                type_id: params.vacationType,
                from_dt: moment(params.period.start, "DD.MM.YYYY").format(
                    "YYYY-MM-DD"
                ),
                to_dt: moment(params.period.end, "DD.MM.YYYY").format(
                    "YYYY-MM-DD"
                )
            });

            if (params.file) {
                body.append("file", params.file);
            }

            const res = await fetch(
                `${api_url}/?auth_key=${token}&r=api/vacations/create`,
                {
                    method: "POST",
                    body
                }
            );

            const json = await res.json();

            return json;
        },

        async updateVacation(ctx, params) {
            const token = ctx.rootState.authToken;

            const body = serialize({
                category: params.type,
                worker_id: params.employee,
                type_id: params.vacationType,
                from_dt: moment(params.period.start, "DD.MM.YYYY").format(
                    "YYYY-MM-DD"
                ),
                to_dt: moment(params.period.end, "DD.MM.YYYY").format(
                    "YYYY-MM-DD"
                ),
                fileLink: params.fileLink
            });

            if (params.file) {
                body.append("file", params.file);
            }

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/vacations/update&id=${params.id}`, token),
                {
                    method: "PUT",
                    body
                }
            );

            const json = await res.json();

            return json;
        },

        async removeVacation(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/vacations/delete&id=${params.id}`, token),
                {
                    method: "DELETE"
                }
            );

            const json = await res.json();

            return json;
        },

        async getEmployeesList(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/list`, token)
            );

            const json = await res.json();

            return json.map(e => ({
                value: e.id,
                label: e.name,
                ...e
            }));
        }
    }
};
